import type { VirtualAppointmentOverviewItem } from '../../../services/virtualAppointmentsOverview';
import { isDueDayReached } from '../../virtual-appointments/virtualAppointmentWeeks';
import { nogosProgressHint } from '../../virtual-appointments/virtualAppointmentNogos';

const MS_PER_DAY = 24 * 60 * 60 * 1000;

export function daysBetween(fromIso: string, toIso: string): number {
    return Math.round(
        (Date.parse(`${toIso}T00:00:00Z`) - Date.parse(`${fromIso}T00:00:00Z`)) / MS_PER_DAY
    );
}

// Fresh patients mirror as aligner 0, which means "not known yet", not "before the first aligner".
function alignerHint(item: VirtualAppointmentOverviewItem): string | null {
    const current = item.patient.currentAligner;
    const target = item.triggerAligner;
    if (target === null) return null;
    if (current === null || current < 1) return 'on ?';
    return current >= target
        ? `on ${current} (reached)`
        : `on ${current} (${target - current} to go)`;
}

function dueDayHint(item: VirtualAppointmentOverviewItem, todayIso: string): string | null {
    if (item.dueDate === null || isDueDayReached(item.dueDate, todayIso)) return null;
    const days = daysBetween(todayIso, item.dueDate);
    return days === 1 ? 'tomorrow' : `in ${days} days`;
}

// Aligner triggers always say where the patient is; week and no-go triggers count down while planned.
export function triggerHint(item: VirtualAppointmentOverviewItem, todayIso: string): string | null {
    if (item.triggerKind === 'aligner') return alignerHint(item);
    if (item.status !== 'planned') return null;
    return item.triggerKind === 'nogos'
        ? nogosProgressHint(item.triggerNogos, item.nogoCount)
        : dueDayHint(item, todayIso);
}
